<script lang="ts">
	import { Router, Route, Link } from "svelte-routing";
	import Normalize from "./Normalize.svelte";
	import Monster from './Monster/index.svelte';
	import Battle from './Monster/components/Battle/index.svelte';
	import SvgDrawer from "./Monster/components/SVGDrawer/SVGDrawer.svelte";

	export let url: string = '';
</script>

<Router url="{url}">
	<Normalize/>
	<Route path="/">
		<Monster code={null}/>
		<SvgDrawer/>
	</Route>
	<Route path="battle" component={Battle} /> 
</Router>

<style>

</style>
